__turbopack_context__.v({
  "buttonWrap": "thcpxq_buttonWrap",
  "container": "thcpxq_container",
  "input": "thcpxq_input",
  "label": "thcpxq_label",
  "list": "thcpxq_list",
  "message": "thcpxq_message",
  "variant--colorId": "thcpxq_variant--colorId",
  "variant--preconCommander": "thcpxq_variant--preconCommander",
  "variant--tag": "thcpxq_variant--tag",
});
